import { useTranslation } from "react-i18next";
import ButtonComponent from "../button/ButtonComponent";
import "./refreshButton.scss"

interface RefreshButtonProps {
    refresh: () => void;
    className?: string;
}

const RefreshButton = ({ refresh }: RefreshButtonProps) => {
    const { t } = useTranslation();
    return (
        <ButtonComponent type="primary" onClick={refresh}>{t('shared.refreshButton.label')}</ButtonComponent>
    );
}

export default RefreshButton;